<div class="h-full surface-ground surface-border border-right-1 padding-py-16">
    @if (!projectService.isSidebarReduced) {
        <div class="w-13rem flex flex-column surface-border border-bottom-none">
            @for (page of categorizedPages; track pIndex; let pIndex = $index) {
                @if (!page.categoryName) {
                    <div class="w-full flex flex-column p-2 surface-border border-bottom-1 gap-px-1">
                        @for (singlePage of page.pages; track i; let i = $index) {
                            <div
                                class="hover:surface-hover border-round-lg w-12rem height-40 padding-12 flex surface-border align-items-center cursor-pointer justify-content-between"
                                [ngClass]="{
                                    'text-primary-700 surface-600':
                                        activePageMenu['activeMenuCategory'] === pIndex &&
                                        activePageMenu['activeCategoryItem'] === i,
                                }"
                                (click)="setPage(singlePage, pIndex, i)"
                            >
                                <div
                                    class="flex align-items-center text-sm line-height-2 justify-content-center gap-8-px"
                                    tooltipPosition="bottom"
                                    pTooltip="{{ singlePage.title || singlePage?.name | translate }}"
                                >
                                    @if (singlePage?.icon) {
                                        <span
                                            class="material-symbols-outlined text-2xl text-primary-600 {{
                                                activePageMenu['activeMenuCategory'] === pIndex &&
                                                activePageMenu['activeCategoryItem'] === i
                                                    ? 'text-primary-700 font-bold'
                                                    : 'text-primary-600'
                                            }}"
                                            >{{ singlePage.icon }}</span
                                        >
                                    } @else {
                                        <img
                                            [src]="
                                                activePageMenu['activeMenuCategory'] === pIndex &&
                                                activePageMenu['activeCategoryItem'] === i
                                                    ? singlePage.activeIcon
                                                    : singlePage.nonActiveIcon
                                            "
                                        />
                                    }
                                    <span
                                        class="font-medium capitalize w-7rem overflow-hidden white-space-nowrap text-overflow-ellipsis {{
                                            activePageMenu['activeMenuCategory'] === pIndex &&
                                            activePageMenu['activeCategoryItem'] === i
                                                ? 'text-primary-700 font-bold'
                                                : 'text-primary-600'
                                        }}"
                                    >
                                        {{ singlePage.title || singlePage?.name | translate }}
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <p-panel
                        styleClass="border-none border-noround shadow-none flex flex-column"
                        class="panel-padding capitalize border-noround border-none padding-8 border-bottom-1 surface-border shadow-none"
                        expandIcon="pi pi-angle-up"
                        collapseIcon="pi pi-angle-down"
                        [toggleable]="true"
                    >
                        <ng-template pTemplate="header">
                            <span
                                class="text-primary-500 font-medium text-xsmall uppercase overflow-hidden text-overflow-ellipsis white-space-nowrap"
                            >
                                {{ page.categoryName }}
                            </span>
                        </ng-template>
                        <ng-template let-isCollapsed pTemplate="headericons">
                            <div class="h-1rem w-1rem">
                                <i
                                    class="pi text-primary-500"
                                    [ngClass]="{ 'pi-chevron-up': !isCollapsed, 'pi-chevron-down': isCollapsed }"
                                ></i>
                            </div>
                        </ng-template>

                        <ng-template pTemplate="content">
                            <div class="flex flex-column gap-1 padding-top-10">
                                @for (singlePage of page.pages; track i; let i = $index) {
                                    <div
                                        class="hover:surface-hover border-round-lg w-full height-40 padding-12 flex surface-border align-items-center cursor-pointer justify-content-between"
                                        [ngClass]="{
                                            'text-bold text-primary-700 surface-600':
                                                activePageMenu['activeMenuCategory'] === pIndex &&
                                                activePageMenu['activeCategoryItem'] === i,
                                        }"
                                        (click)="setPage(singlePage, pIndex, i)"
                                    >
                                        <div
                                            class="flex align-items-center text-sm line-height-2 justify-content-center gap-8-px"
                                            tooltipPosition="bottom"
                                            pTooltip="{{ singlePage.title || singlePage?.name }}"
                                        >
                                            @if (singlePage?.icon) {
                                                <span
                                                    class="material-symbols-outlined text-2xl text-primary-600 {{
                                                        activePageMenu['activeMenuCategory'] === pIndex &&
                                                        activePageMenu['activeCategoryItem'] === i
                                                            ? 'text-primary-700 font-bold'
                                                            : 'text-primary-600'
                                                    }}"
                                                    >{{ singlePage.icon }}</span
                                                >
                                            } @else {
                                                <img
                                                    [src]="
                                                        activePageMenu['activeMenuCategory'] === pIndex &&
                                                        activePageMenu['activeCategoryItem'] === i
                                                            ? 'assets/icons/inbox.svg'
                                                            : 'assets/icons/inbox-colorless.svg'
                                                    "
                                                />
                                            }
                                            <span
                                                class="font-medium capitalize w-7rem overflow-hidden white-space-nowrap text-overflow-ellipsis {{
                                                    activePageMenu['activeMenuCategory'] === pIndex &&
                                                    activePageMenu['activeCategoryItem'] === i
                                                        ? 'text-primary-700 font-bold'
                                                        : 'text-primary-600'
                                                }}"
                                            >
                                                {{ singlePage.title || singlePage?.name }}
                                            </span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </ng-template>
                    </p-panel>
                }
            }
        </div>
    } @else {
        <div class="w-4rem flex flex-column surface-border border-bottom-none surface-ground">
            @for (page of categorizedPages; track pIndex; let pIndex = $index) {
                <div
                    class="w-full gap-px-1 surface-border border-bottom-1 padding-8 flex flex-column justify-content-center"
                >
                    @for (singlePage of page.pages; track $index) {
                        <div class="w-full">
                            <a
                                class="hover:surface-hover flex align-items-center justify-content-center border-round-lg height-40 width-40 padding-8 cursor-pointer"
                                (click)="setPage(singlePage, pIndex, $index)"
                                [ngClass]="{
                                    'text-bold text-primary-700 surface-600':
                                        activePageMenu['activeMenuCategory'] === pIndex &&
                                        activePageMenu['activeCategoryItem'] === $index,
                                }"
                            >
                                <div
                                    class="flex align-items-center justify-content-center gap-2"
                                    tooltipPosition="bottom"
                                    pTooltip="{{ singlePage.title || singlePage?.name }}"
                                >
                                    @if (singlePage?.icon) {
                                        <span
                                            class="material-symbols-outlined text-2xl text-primary-600 {{
                                                activePageMenu['activeMenuCategory'] === pIndex &&
                                                activePageMenu['activeCategoryItem'] === $index
                                                    ? 'text-primary-700 font-bold'
                                                    : 'text-primary-600'
                                            }}"
                                            >{{ singlePage.icon }}</span
                                        >
                                    } @else {
                                        <img
                                            [src]="
                                                activePageMenu['activeMenuCategory'] === pIndex &&
                                                activePageMenu['activeCategoryItem'] === $index
                                                    ? singlePage.activeIcon
                                                    : singlePage.nonActiveIcon
                                            "
                                        />
                                    }
                                </div>
                            </a>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
